import React from 'react'

import CheckIcon from '../../assets/icons/check';
import CloseIcon from '../../assets/icons/close';

import AboutmeIcon from '../../assets/icons/aboutme'
import AdobeIcon from '../../assets/icons/adobe'
import AmazonIcon from '../../assets/icons/amazon'
import AppleIcon from '../../assets/icons/apple'
import ArchiveorgIcon from '../../assets/icons/archiveorg'
import AirbnbIcon from '../../assets/icons/aribnb'
import AtlassianIcon from '../../assets/icons/atlassian'
import BitmojiIcon from '../../assets/icons/bitmoji'
import BookingIcon from '../../assets/icons/booking'
import BukalapakIcon from '../../assets/icons/bukalapak'
import CodecademyIcon from '../../assets/icons/codecademy'
import DeliverooIcon from '../../assets/icons/deliveroo'
import DiscordIcon from '../../assets/icons/discord'
import DisneyplusIcon from '../../assets/icons/disneyplus'
import DuolingoIcon from '../../assets/icons/duolingo'
import EbayIcon from '../../assets/icons/ebay'
import EnvatoIcon from '../../assets/icons/envato'
import EventbriteIcon from '../../assets/icons/eventbrite'
import EvernoteIcon from '../../assets/icons/evernote'
import FacebookIcon from '../../assets/icons/facebook'
import FirefoxIcon from '../../assets/icons/firefox'
import FlickrIcon from '../../assets/icons/flickr'
import FlipkartIcon from '../../assets/icons/flipkart'
import FoursquareIcon from '../../assets/icons/foursquare'
import FreelancerIcon from '../../assets/icons/freelancer'
import GiphyIcon from '../../assets/icons/giphy'
import GithubIcon from '../../assets/icons/github'
import GoogleIcon from '../../assets/icons/google'
import GravatarIcon from '../../assets/icons/gravatar'
import HubspotIcon from '../../assets/icons/hubspot'
import ImgurIcon from '../../assets/icons/imgur'
import InstagramIcon from '../../assets/icons/instagram'
import KakaoIcon from '../../assets/icons/kakao'
import KomootIcon from '../../assets/icons/komoot'
import LastfmIcon from '../../assets/icons/lastfm'
import LazadaIcon from '../../assets/icons/lazada'
import LinkedinIcon from '../../assets/icons/linkedin'
import MailruIcon from '../../assets/icons/mailru'
import MicrosoftIcon from '../../assets/icons/microsoft'
import MyspaceIcon from '../../assets/icons/myspace'
import NetflixIcon from '../../assets/icons/netflix'
import NikeIcon from '../../assets/icons/nike'
import OkIcon from '../../assets/icons/ok'
import PatreonIcon from '../../assets/icons/patreon'
import PinterestIcon from '../../assets/icons/pinterest'
import PlurkIcon from '../../assets/icons/plurk'
import QuoraIcon from '../../assets/icons/quora'
import QzoneIcon from '../../assets/icons/qzone'
import RamblerIcon from '../../assets/icons/rambler'
import RappiIcon from '../../assets/icons/rappi'
import ReplitIcon from '../../assets/icons/replit'
import SamsungIcon from '../../assets/icons/samsung'
import SkypeIcon from '../../assets/icons/skype'
import SnapchatIcon from '../../assets/icons/snapchat'
import SoundcloudIcon from '../../assets/icons/soundcoud'
import SpotifyIcon from '../../assets/icons/spotify'
import StravaIcon from '../../assets/icons/strava'
import TaringaIcon from '../../assets/icons/taringa'
import TokopediaIcon from '../../assets/icons/tokopedia'
import TreehouseIcon from '../../assets/icons/treehouse'
import TumblrIcon from '../../assets/icons/tumblr'
import TwitterIcon from '../../assets/icons/twitter'
import VenmoIcon from '../../assets/icons/venmo'
import ViemoIcon from '../../assets/icons/vimeo'
import VivinoIcon from '../../assets/icons/vivino'
import VkontakteIcon from '../../assets/icons/vkontakte'
import WattpadIcon from '../../assets/icons/wattpad'
import WeiboIcon from '../../assets/icons/weibo'
import WordpressIcon from '../../assets/icons/wordpress'
import XingIcon from '../../assets/icons/xing'
import YahooIcon from '../../assets/icons/yahoo'
import YandexIcon from '../../assets/icons/yandex'
import ZohoIcon from '../../assets/icons/zoho'

function PhoneReport() {
    return (
        <div className="sandbox_report_wrapper">
            <h2>Result report:</h2>
            <div className="sandbox_tags">
                <div className="tag tag_success">
                    <span>Válido</span>
                </div>
                <div className="tag tag_error">
                    <span>No desechable</span>
                </div>
            </div>
            <div className="api_log_list">
                <h4>Score</h4>
                <div className="api_log_score">
                    <span>0</span>
                    <p>Una puntuación de 0-100 que indica la probabilidad de que la dirección de correo electrónico del usuario sea fraudulenta. Un correo electrónico con una puntuación de 8 o más es riesgoso.</p>
                </div>
            </div>
            <div className="api_log_list">
                <h4>Detalles del dominio</h4>
                <div class="api_log_detail">
                    <span>País</span>
                    <span class="api_log_detail_value">MX</span>
                </div>
                <div class="api_log_detail">
                    <span>Tipo</span>
                    <span class="api_log_detail_value">mobile</span>
                </div>
                <div class="api_log_detail">
                    <span>Operador</span>
                    <span class="api_log_detail_value">-</span>
                </div>
            </div>

            <div className="api_log_list">
                <h4>Detalles de la cuenta</h4>
                <div className="report_social_row">
                    <AboutmeIcon />
                    <span>aboutme</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <AdobeIcon />
                    <span>adobe</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <AmazonIcon />
                    <span>amazon</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <AppleIcon />
                    <span>apple</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <ArchiveorgIcon />
                    <span>archiveorg</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <AirbnbIcon />
                    <span>airbnb</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <AtlassianIcon />
                    <span>atlassian</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <BitmojiIcon />
                    <span>bitmoji</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <BookingIcon />
                    <span>booking</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <BukalapakIcon />
                    <span>bukalapak</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <CodecademyIcon />
                    <span>codecademy</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <DeliverooIcon />
                    <span>deliveroo</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <DiscordIcon />
                    <span>discord</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <DisneyplusIcon />
                    <span>disneyplus</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <DuolingoIcon />
                    <span>duolingo</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <EbayIcon />
                    <span>ebay</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <EnvatoIcon />
                    <span>envato</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <EventbriteIcon />
                    <span>eventbrite</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <EvernoteIcon />
                    <span>evernote</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <FacebookIcon />
                    <span>facebook</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <FirefoxIcon />
                    <span>firefox</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <FlickrIcon />
                    <span>flickr</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <FlipkartIcon />
                    <span>flipkart</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <FoursquareIcon />
                    <span>foursquare</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <FreelancerIcon />
                    <span>freelancer</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <GiphyIcon />
                    <span>giphy</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <GithubIcon />
                    <span>github</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <GoogleIcon />
                    <span>google</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <GravatarIcon />
                    <span>gravatar</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <HubspotIcon />
                    <span>hubspot</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <ImgurIcon />
                    <span>imgur</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <InstagramIcon />
                    <span>instagram</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <KakaoIcon />
                    <span>kakao</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <KomootIcon />
                    <span>komoot</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <LastfmIcon />
                    <span>lastfm</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <LazadaIcon />
                    <span>lazada</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <LinkedinIcon />
                    <span>linkedin</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <MailruIcon />
                    <span>mailru</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <MicrosoftIcon />
                    <span>microsoft</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <MyspaceIcon />
                    <span>myspace</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <NetflixIcon />
                    <span>netflix</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <NikeIcon />
                    <span>nike</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <OkIcon />
                    <span>ok</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <PatreonIcon />
                    <span>patreon</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <PinterestIcon />
                    <span>pinterest</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <PlurkIcon />
                    <span>plurk</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <QuoraIcon />
                    <span>quora</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <QzoneIcon />
                    <span>qzone</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <RamblerIcon />
                    <span>rambler</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <RappiIcon />
                    <span>rappi</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <ReplitIcon />
                    <span>replit</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <SamsungIcon />
                    <span>samsung</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <SkypeIcon />
                    <span>skype</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <SnapchatIcon />
                    <span>snapchat</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <SoundcloudIcon />
                    <span>soundcoud</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <SpotifyIcon />
                    <span>spotify</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <StravaIcon />
                    <span>strava</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <TaringaIcon />
                    <span>taringa</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <TokopediaIcon />
                    <span>tokopedia</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <TreehouseIcon />
                    <span>treehouse</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <TumblrIcon />
                    <span>tumblr</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <TwitterIcon />
                    <span>twitter</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <VenmoIcon />
                    <span>venmo</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <ViemoIcon />
                    <span>vimeo</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <VivinoIcon />
                    <span>vivino</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <VkontakteIcon />
                    <span>vkontakte</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <WattpadIcon />
                    <span>wattpad</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <WeiboIcon />
                    <span>weibo</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <WordpressIcon />
                    <span>wordpress</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <XingIcon />
                    <span>xing</span>
                    <span className="error">No registrado</span>
                </div>
                <div className="report_social_row">
                    <YahooIcon />
                    <span>yahoo</span>
                    <span className="success">Registrado</span>
                </div>
                <div className="report_social_row">
                    <YandexIcon />
                    <span>yandex</span>
                    <span>-</span>
                </div>
                <div className="report_social_row">
                    <ZohoIcon />
                    <span>zoho</span>
                    <span className="error">No registrado</span>
                </div>
            </div>
        </div>
    )
}

export default PhoneReport